import { types } from "react-bricks/frontend";

const pageTypes: types.IPageType[] = [
  {
    name: "page",
    pluralName: "pages",
    defaultLocked: false,
    defaultStatus: types.PageStatus.Draft,
    getDefaultContent: () => [],
    customFields: [
      {
        groupName: "header-footer",
        defaultOpen: false,
        props: [
          {
            name: "hideHeader",
            label: "Hide Header?",
            type: types.SideEditPropType.Boolean,
          },
          {
            name: "hideFooter",
            label: "Hide Footer?",
            type: types.SideEditPropType.Boolean,
          },
        ],
      },
    ],
    categories: [
      {
        category: "Old Pages",
      },
      {
        category: "Other",
      },
      {
        category: "Event Pages",
      },
      {
        category: "Website Pages",
      },
      {
        category: "Event Pages",
      },
    ],
  },
];

export default pageTypes;
